// polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'styles/index.less'
import 'favicon.png'
import 'libraries/front-end-core/helpers/scrolling'
import { initTrack } from 'services/AnalyticsService'
import Clipboard from 'clipboard'
import { toast } from 'react-toastify'
import { DOMReady } from 'libraries/front-end-core/services/WindowService'
import LayoutWrapper from 'components/LayoutWrapper'
import { LEGISLATION_FOLDERS, USER_ADMIN_ENABLED } from 'constants/feature-flags'
import debug from 'libraries/front-end-core/core/debug'
import Router from 'libraries/front-end-core/core/Router'
import Login from 'pages/login'
import Account from 'pages/account'
import CurrentAwarenessReview from 'pages/currentawarenessreview'
import CurrentAwareness from 'pages/currentawareness'
import CurrentAwarenessArticle from 'pages/currentawarenessarticle'
import Dashboard from 'pages/dashboard'
import QAMenu from 'pages/qamenu'
import QAContent from 'pages/qacontent'
import QAReview from 'pages/qareview'
import Search from 'pages/search'
import SmartSearch from 'pages/smartsearch'
import Static from 'pages/static'
import Legislation from 'pages/legislation'
import LegislationMenu from 'pages/legislationmenu'
import LegislationReview from 'pages/legislationreview'
import LegislationFolders from 'pages/legislationfolders'
import LegislationCategories from 'pages/legislationcategories'
import NotFound from 'pages/notfound'
import PrecedentsAll from 'pages/precedentsall'
import PrecedentsContent from 'pages/precedentscontent'
import PrecedentsReview from 'pages/precedentsreview'
import DocumentsMenu from 'pages/documentsmenu'
import DocumentsAll from 'pages/documentsall'
import DocumentsContent from 'pages/documentscontent'
import DocumentsReview from 'pages/documentsreview'
import Share from 'pages/share'
import Utils from 'pages/utils'
import HashRewrite from 'pages/hashrewrite'
import MwOverview from 'pages/mwoverview'
import MwListDeals from 'pages/mwlistdeals'
import MwAnalytics from 'pages/mwanalytics'
import MwDealDetails from 'pages/mwdealdetails'
import MwDealCompare from 'pages/mwdealcompare'
import UserAdmin from 'pages/useradmin'
import PartnerConsent from 'pages/partner-consent'
import AccessDenied from 'pages/access-denied'

import RootRedirect from 'pages/redirects/rootRedirect'
import LegacyHomepage from 'pages/redirects/legacyHomepage'
import LegacyArticle from 'pages/redirects/legacyArticle'
import LegacyNewsArchive from 'pages/redirects/legacyNewsArchive'
import LegacyNewsReview from 'pages/redirects/legacyNewsReview'
import LegacyQaMenu from 'pages/redirects/legacyQaMenu'
import LegacyQaContent from 'pages/redirects/legacyQaContent'
import LegacyQaReview from 'pages/redirects/legacyQaReview'
import LegacyLegislationMenu from 'pages/redirects/legacyLegislationMenu'
import LegacyLegislationCategories from 'pages/redirects/legacyLegislationCategories'
import LegacyLegislation from 'pages/redirects/legacyLegislation'
import LegacyLegislationAll from 'pages/redirects/legacyLegislationAll'
import LegacyLegislationReview from 'pages/redirects/legacyLegislationReview'
import LegacyDocuments from 'pages/redirects/legacyDocuments'
import LegacyDocumentsAll from 'pages/redirects/legacyDocumentsAll'
import LegacyAutomatedDocuments from 'pages/redirects/legacyAutomatedDocuments'
import LegacyDocumentsReview from 'pages/redirects/legacyDocumentsReview'

// Recharts' ResponsiveContainer triggers this benign browser notification when
// chart rendering alters its own size mid-frame. Suppress it so the
// webpack-dev-server overlay doesn't treat it as a hard error.
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation()
  }
}, true)

const routes = [
  HashRewrite,
  Login,
  Account,
  MwOverview,
  MwAnalytics,
  MwListDeals,
  MwDealDetails,
  MwDealCompare,
  CurrentAwareness,
  CurrentAwarenessArticle,
  CurrentAwarenessReview,
  QAMenu,
  QAContent,
  QAReview,
  Search,
  SmartSearch,
  Static,
  LegislationMenu,
  LegislationReview,
  ...(LEGISLATION_FOLDERS ? [LegislationFolders, LegislationCategories] : []),
  Legislation,
  PrecedentsAll,
  PrecedentsContent,
  PrecedentsReview,
  DocumentsMenu,
  DocumentsAll,
  DocumentsContent,
  DocumentsReview,
  Share,
  Utils,
  ...(USER_ADMIN_ENABLED ? [UserAdmin] : []),
  PartnerConsent,
  AccessDenied,
  Dashboard,
  LegacyArticle,
  LegacyNewsArchive,
  LegacyNewsReview,
  LegacyQaMenu,
  LegacyQaContent,
  LegacyQaReview,
  LegacyLegislationMenu,
  LegacyLegislationCategories,
  LegacyLegislationAll,
  LegacyLegislation,
  LegacyLegislationReview,
  LegacyDocuments,
  LegacyDocumentsAll,
  LegacyAutomatedDocuments,
  LegacyDocumentsReview,
  LegacyHomepage,
  RootRedirect,
  NotFound
]

// The Router tries to match the routes in the order they appear in the routes array.
const app = new Router({
  routes,
  layout: LayoutWrapper,
  urlMapping: (url) => url.replace(/^\/?ms\//ig, '')
})

DOMReady.subscribe(
  () => {
    initTrack(app)
    app.start()
  },
  (err) => debug.log(err.stack)
)

new Clipboard('[data-clipboard-text]') // eslint-disable-line

toast.configure({
  position: 'bottom-right',
  pauseOnFocusLoss: false,
  autoClose: 3000,
  draggable: false,
  closeButton: false,
  toastClassName: 'bg-dark-sea-green-2 white'
})
